import React from 'react'
import "./offer.css"

function Offer() {
   
    const voucher =[
        {price:"Rs.350", offer: "Spend Rs.4,999 get Rs.350 off", date:"2022.09.14-2022.09.26"},
        {price:"Rs.1,000", offer: "Spend Rs.9,999 get Rs.1000 off", date:"2022.09.14-2022.09.26"},
        {price:"Rs.1,500", offer: "Spend Rs.19,999 get Rs.1,500 off", date:"2022.09.14-2022.09.26"},
        {price:"Rs.2,500", offer: "Spend Rs.34,999 get Rs.2,500 off", date:"2022.09.14-2022.09.26"},
        {price:"Rs.4,000", offer: "Spend Rs.49,999 get Rs.4,000 off", date:"2022.09.14-2022.09.26"},
        {price:"Rs.5,000", offer: "Spend Rs.74,999 get Rs.5,000 off", date:"2022.09.14-2022.09.26"},
    ]   
    
    const handleClick = () => {
        document.getElementById("myDropdown").classList.toggle("show");
    }

    window.onclick = (e) => {
        if(!e.target.matches('.dropbtn')){
            var myDropdown = document.getElementById("myDropdown");
            if(myDropdown.classList.contains('show')){
                myDropdown.classList.remove('show');
            }
        }
    }
    
  return (
    <div>

        <div className='dropdown'>
            <button onClick={handleClick} className='dropbtn'> 
                {voucher[0].offer}   {"    "}
                <i className="fa fa-caret-down"></i>
            </button>

            <div className='voucher-content' id='myDropdown'>
                {voucher.map((item) => 
                            <div className='voucher-container'>
                                <p className='voucher-price'>{item.price}</p>
                                <p className='voucher-offer'>{item.offer}</p>
                                <div className='voucher-date'>
                                    <p>{item.date}</p>
                                    <button>Collect</button>
                                </div>
                            </div>

                    )}
            </div>
        </div>

    </div>
  )
}

export default Offer